import {useEffect} from 'react'

// Work open in this tab that choosing another business would throw away (the user, 2026-10-26): an invoice form while it
// is open. Every way of choosing a business asks first (switchBusiness, the pickers).
const openWork = new Map<symbol, string>()

/** Keeps `what` («فرم صورتحساب») in the tab's open work while the component is mounted and `active`. */
export const useUnsavedWork = (what: string, active = true) => {
  useEffect(() => {
    if (!active) return
    const key = Symbol(what)
    openWork.set(key, what)
    return () => {
      openWork.delete(key)
    }
  }, [what, active])
}

export const hasUnsavedWork = () => openWork.size > 0

/** True when nothing is open, or the user agrees to leave it for another business. */
export const confirmLeavingUnsavedWork = (
  confirm: (message: string) => boolean = window.confirm
) => {
  if (openWork.size === 0) return true
  const what = Array.from(new Set(openWork.values())).join('، ')
  return confirm(
    `${what} در این تب باز است. با رفتن به کسب‌وکار دیگر، آنچه ذخیره نشده از دست می‌رود. ادامه می‌دهید؟`
  )
}
